export type Bilingual = { en: string; bn: string };

export interface CasioModel {
  id: string;
  name: string;
  type: Bilingual;
  functions: number;
  display: Bilingual;
  priceBdt: string;
  bestFor: Bilingual;
  href: string;
  isEmulator: boolean;
  popular?: boolean;
  comingSoon?: boolean;
  noteForLink?: Bilingual;
}

export const CASIO_MODELS: CasioModel[] = [
  {
    id: "fx-82ms",
    name: "FX-82MS",
    type: { en: "Basic Scientific", bn: "সাধারণ সাইন্টিফিক" },
    functions: 240,
    display: { en: "10 + 2 lines", bn: "১০ + ২ লাইন" },
    priceBdt: "৳1,500–2,000",
    bestFor: { en: "SSC basic math & science", bn: "এসএসসি বেসিক গণিত ও বিজ্ঞান" },
    href: "/scientific-calculator",
    isEmulator: false,
    noteForLink: { en: "Use generic scientific calculator", bn: "জেনেরিক সাইন্টিফিক ব্যবহার করুন" },
  },
  {
    id: "fx-100ms",
    name: "FX-100MS",
    type: { en: "Scientific", bn: "সাইন্টিফিক" },
    functions: 300,
    display: { en: "10 + 2 lines", bn: "১০ + ২ লাইন" },
    priceBdt: "৳2,000–2,500",
    bestFor: { en: "SSC / HSC core syllabus", bn: "এসএসসি / এইচএসসি মূল সিলেবাস" },
    href: "/scientific-calculator",
    isEmulator: false,
    noteForLink: { en: "Use generic scientific calculator", bn: "জেনেরিক সাইন্টিফিক ব্যবহার করুন" },
  },
  {
    id: "fx-991es",
    name: "FX-991ES Plus",
    type: { en: "Advanced Scientific", bn: "অ্যাডভান্সড সাইন্টিফিক" },
    functions: 417,
    display: { en: "Natural Display 96×31", bn: "ন্যাচারাল ডিসপ্লে ৯৬×৩১" },
    priceBdt: "৳2,500–3,500",
    bestFor: { en: "SSC / HSC / admission tests", bn: "এসএসসি / এইচএসসি / ভর্তি পরীক্ষা" },
    href: "/casio-fx-991es",
    isEmulator: true,
    popular: true,
  },
  {
    id: "fx-991ex",
    name: "FX-991EX ClassWiz",
    type: { en: "Advanced + ClassWiz", bn: "অ্যাডভান্সড + ক্লাসউইজ" },
    functions: 552,
    display: { en: "Natural-V.P.A.M. 192×63", bn: "ন্যাচারাল V.P.A.M. ১৯২×৬৩" },
    priceBdt: "৳3,800–5,500",
    bestFor: { en: "HSC+ / university engineering", bn: "এইচএসসি+ / বিশ্ববিদ্যালয় ইঞ্জিনিয়ারিং" },
    href: "/casio-fx-991ex",
    isEmulator: true,
  },
  {
    id: "fx-50fh",
    name: "FX-50FH",
    type: { en: "Programmable Scientific", bn: "প্রোগ্রামেবল সাইন্টিফিক" },
    functions: 279,
    display: { en: "10 + 2 lines", bn: "১০ + ২ লাইন" },
    priceBdt: "৳3,000–4,000",
    bestFor: { en: "Programmable formulas (V2)", bn: "প্রোগ্রামেবল সূত্র (V2)" },
    href: "/casio-calculator",
    isEmulator: false,
    comingSoon: true,
  },
  {
    id: "fx-cg50",
    name: "FX-CG50",
    type: { en: "Color Graphing", bn: "কালার গ্রাফিং" },
    functions: 1000,
    display: { en: "Color graphing 384×216", bn: "কালার গ্রাফিং ৩৮৪×২১৬" },
    priceBdt: "৳25,000+",
    bestFor: { en: "University specialty courses", bn: "বিশ্ববিদ্যালয়ের বিশেষ কোর্স" },
    href: "/graphing-calculator",
    isEmulator: false,
    noteForLink: { en: "Try web graphing calculator", bn: "ওয়েব গ্রাফিং ক্যালকুলেটর দেখুন" },
  },
];
